import { Controller } from "@hotwired/stimulus"

// Shows the "Office location" picker only when the Location type above it is set to
// "Office address". Attached to the select itself, so it needs no wrapping element.
export default class extends Controller {
  connect() {
    this.apply();
  }

  toggle() {
    this.apply();
  }

  apply() {
    const groupId = this.element.dataset.officeGroup;
    if (!groupId) return;

    const group = document.getElementById(groupId);
    if (!group) return;

    group.hidden = this.element.value !== "office_address";
  }
}
